
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/marker.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-model-marker-demo-marker-native","docs-api-model-marker-demo-marker-path","docs-api-model-marker-demo-marker-custom","docs-api-model-marker-demo-marker-normalize-path","docs-api-model-marker-demo-marker-image","docs-api-model-marker-demo-marker-tagname"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/marker.zh.md?type=demo')
};